/**
 * Core function for logarithmic decelerating shape
 * Inverted version of log-accel to create a decelerating effect
 */
export function calculateLogDecel(x: number): number {
  // Using the same base function as log-accel but inverted
  return 2 * Math.exp(-x / 2);
}

export interface LogDecelInterval {
  a: number;
  b: number;
}

export interface LogDecelBuild {
  id: string;
  interval: LogDecelInterval;
}
